import React, { Fragment } from "react";

import BrandsTable from "./Brands";
import ProjectService from "./ProjectService";
import ProjectType from "./ProjectType";
import Scale from "./Scale";
import AreaTypeContainer from "./AreaType";

const ProjectDetail = () => {
  return (
    <Fragment>
      <BrandsTable />
      <ProjectService />
      <ProjectType />
      <Scale />
      <AreaTypeContainer />
    </Fragment>
  );
};

export default ProjectDetail;
